export default __webpack_public_path__ + "static/media/intelLogo.653a3341.png";